<template>
  <!-- 供应商等级工程类 -->
  <div class="ccui-app-container">
    <div
      class="ccui-advanced-search-wrapper ccui-clearfix"
      ref="advancedSearchWrapper"
    >
      <div class="ccui-search-wrapper">
        <div class="ccui-tab-wrapper">
          <el-button
            type="table-top"
            size="mini"
            @click="
              $router.push('/baseOpera/supplierGrade/supplierGradeEngineering')
            "
            ref="baseOpera-digFile"
            >工程类</el-button
          >
          <el-button type="table-top-active" size="mini" ref="baseOpera-equip">
            物资类
          </el-button>
          <el-button
            type="table-top"
            size="mini"
            @click="
              $router.push('/baseOpera/supplierGrade/supplierGradeService')
            "
            ref="baseOpera-contract"
          >
            服务类
          </el-button>
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            :disabled="isDisabled"
            v-if="isShowBtn"
            @click="manageGrade()"
            >维护等级</el-button
          >
        </div>
      </div>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table :data="tableData" border type="expand" row-key="index">
        <el-table-column
          :show-overflow-tooltip="true"
          type="index"
          label="序号"
          width="60"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="gradeName"
          label="等级名称"
          width="180"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="gradeType"
          label="等级类型"
          :formatter="formatType"
        >
        </el-table-column>
      </el-table>
    </div>
    <!--    维护等级-->
    <supplierGradeDia
      @gradeDialogCancel="gradeDialogCancel"
      @gradeDialogSure="gradeDialogSure"
      :gradeList="gradeList"
      :supplierTypeCode="supplierTypeCode"
      v-if="showDia"
      ref="gradeDiaShow"
    >
    </supplierGradeDia>
  </div>
</template>

<script>
import supplierGradeDia from "../../components/supplierGradeDia";
import { queryBaseData, supplierGradeList } from "../../api/appSet";

export default {
  name: "baseOpera-supplierGradeEngineering",
  components: {
    supplierGradeDia
  },
  data() {
    return {
      supplierTypeCode: "B",
      tableData: [],
      tableMaxHeight: 0,
      gradeList: [],
      showDia: false,
      formatType(row, column, cellValue, index) {
        return cellValue == "0"
          ? "合格"
          : cellValue == "1"
          ? "不合格"
          : "未评级";
      },
      isDisabled: false, //添加分类是否可用，如果是组织分类就不可用
      isShowBtn: false
    };
  },
  created() {
    this.addBtnAble();
    this.getList();
  },
  mounted() {
    this.handleSizeBegin();
  },
  methods: {
    // tab切换
    tabChange(data) {
      this.$router.push({ name: `baseOpera-${data}` });
    },
    handleSizeBegin() {
      this.$nextTick(() => {
        this.computeTableHeight();
      });
      // 浏览器调整大小时，表格高度实时改变
      window.onresize = () => {
        this.computeTableHeight();
      };
    },
    // 计算表格高度方法
    computeTableHeight() {
      // 获取表格所占区域的总高度
      let appContainerHeight = document.documentElement.clientHeight - 160 - 25;
      // 获取搜索区域的高度
      this.tableMaxHeight =
        appContainerHeight - 90 > 0 ? appContainerHeight - 45 : 0;
    },
    //添加分类按钮是否可用
    addBtnAble() {
      const obj = { supplierType: "2" };
      queryBaseData(obj).then(res => {
        this.isDisabled = res.data.data.supplierClass == "2";
        this.isShowBtn = true;
      });
    },
    getList() {
      // 基础数据-查询供应商类型树
      // 页签ID：A-工程类 B-物资类 C-服务类
      const obj = { supplierTypeCode: "B" };
      supplierGradeList(obj).then(res => {
        if (res.data.data.length > 0) {
          this.gradeList = res.data.data.map(function(item) {
            item.isLeaf = item.isLeaf === "1";
            // item.gradeType =
            //   item.gradeType == "0"
            //     ? "合格"
            //     : item.gradeType == "1"
            //     ? "不合格"
            //     : "未评级";
            return item;
          });
          this.tableData = this.gradeList;
        }
      });
    },

    // 维护供应商等级
    manageGrade() {
      this.showDia = true;
    },
    gradeDialogSure(val) {
      this.showDia = val;
      this.getList();
    },

    // 维护供应商等级取消
    gradeDialogCancel(val) {
      this.showDia = val;
    }
  }
};
</script>

<style scoped lang="scss">
.tab-text {
  color: #4a4a4a;
  margin: -3px 0 20px 0;
  font-size: 13px;
}

/deep/ .ccui-multifunctional-table-wrapper .el-table .el-table__body-wrapper {
  max-height: 19960px !important;
}
/deep/
  .ccui-multifunctional-table-wrapper
  .el-table
  tbody
  tr
  td:last-child
  .cell {
  padding-left: 10px !important;
}
</style>
